import React, { useState } from 'react';
import Image from '../Image/Image';
import Button from '../form-elements/Button';
import Modal from '../Modal/Modal';

export default function VehicleIdentNumInfoDialog() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Button modifier="link" onClick={() => setIsOpen(true)}>
                <i data-uk-icon="info" className='hover-info' />
            </Button>
            <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} contentLabel="">
                <div className="uk-modal-body uk-padding-remove">
                    <Button modifier="text" className="uk-modal-close-default" onClick={() => setIsOpen(false)}>
                        <i data-uk-icon="close" />
                    </Button>
                    <div className="uk-flex uk-padding">
                        <div className="uk-flex-1">
                            <div className="uk-margin-small-top">
                                <div className="uk-text-large uk-text-bold uk-margin-bottom text-dark">
                                    Wo finde ich die Fahrgestellnummer / FIN (17-stellig)?
                                </div>
                                <div className="uk-margin-bottom uk-text-large text-dark">
                                    Nehmen Sie Ihre <span className="uk-text-bold">Autopapiere (Zulassungsbescheinigung Teil 1)</span> zur
                                    Hand.
                                </div>
                                <div className="uk-text-large">
                                    <span className="uk-text-bold">Unter E</span> finden Sie die Fahrgestellnummer /
                                    Fahrzeug-Identifizierungsnummer (FIN)
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Image
                            alt="Zulassungsbescheinigung"
                            src="https://techno-images.s3.eu-central-1.amazonaws.com/images/assets/Zulassungsbescheinigung.png"
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
}
